<vdr-facet-value-selector
    *ngIf="facets$ | async as facets"
    [readonly]="readonly"
    [facets]="facets"
    [formControl]="formControl"
></vdr-facet-value-selector>
